export default [
  {
    path: '/candidate/account',
    meta: { auth: 'candidate' },
    component: () => {
      return import(/* webpackChunkName: "candidate-account" */ '@/views/candidates/Settings.vue')
    },
  },
  {
    path: '/candidate/applications/:id',
    meta: { auth: 'candidate' },
    component: () =>
      import(/* webpackChunkName: "candidate-application" */ '@/views/candidates/Application.vue'),
  },
  {
    path: '/candidate/opportunities/:id/apply',
    meta: { auth: 'candidate' },
    props: true,
    component: () => {
      return import(/* webpackChunkName: "candidate-application-form" */ '@/views/candidates/Apply.vue')
    },
  },
  {
    path: '/candidate/profile',
    meta: { auth: 'candidate' },
    component: () => {
      return import(/* webpackChunkName: "candidate-profile" */ '@/views/candidates/Profile.vue')
    },
  },
  {
    path: '/candidate/documents',
    meta: { auth: 'candidate' },
    component: () => {
      return import(/* webpackChunkName: "candidate-profile" */ '@/views/candidates/Documents.vue')
    },
  },
  {
    path: '/candidate/signup',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/candidate/messages',
    meta: { auth: 'candidate' },
    component: () => {
      return import(/* webpackChunkName: "candidate-messages" */ '@/views/candidates/Messages.vue')
    },
  },
]
